export const Country = {
  Sweden: "SE",
  UK: "GB",
} as const;
